import type { SubjectScheme } from "@/natsstubs/wire/context";

interface SessionIdentityStore {
  natsScheme: SubjectScheme;
  user: { role?: string };
}

interface AuthIdentity {
  nats_subject_scheme?: SubjectScheme;
  role?: string;
}

/**
 * authserver minted the refreshed NATS cookie for this identity; if it differs
 * from what the page runs on, only a reload rebuilds the connection and subjects.
 * An older authserver reports no scheme, which means the legacy shape. Both auth endpoints do
 * report `role` today — absent is only tolerated so dropping it could never turn
 * every ordinary token refresh into a reload.
 */
export function identityChanged(store: SessionIdentityStore, data: AuthIdentity): boolean {
  return (
    (data.nats_subject_scheme ?? "v1") !== store.natsScheme ||
    (data.role !== undefined && data.role !== store.user.role)
  );
}
